import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import LoginPopup from '../../Components/Popups/LoginPopup';
import ForgottenPasswordPopup from '../../Components/Popups/ForgottenPasswordPopup';
import RegistrationPopup from '../../Components/Popups/RegistrationPopup';

import { commonStyles } from '../../styles/styles';

const LoginView = ({
  classes,
  showForgottenPopup,
  handlePopupToggle,
  showRegistrationPopup,
  isShowLogin,
  handleForgottenPopup,
  handleRegistrationPopup,
  isDeactivated
}) => (
  <div className={classes.app}>
    {showForgottenPopup && <ForgottenPasswordPopup handleLoginPopup={handlePopupToggle} />}
    {showRegistrationPopup && <RegistrationPopup handleLoginPopup={handlePopupToggle} />}
    {isShowLogin && (
      <LoginPopup
        handleForgottenPopup={handleForgottenPopup}
        handleRegistrationPopup={handleRegistrationPopup}
        isDeactivated={isDeactivated}
      />
    )}
  </div>
);

LoginView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  showForgottenPopup: PropTypes.bool,
  showRegistrationPopup: PropTypes.bool,
  isShowLogin: PropTypes.bool,
  handlePopupToggle: PropTypes.func,
  handleForgottenPopup: PropTypes.func,
  handleRegistrationPopup: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(LoginView);
